/*eslint-disable */
import { useEffect } from 'react';
import { connect } from 'formik';

const OnSubmitValidationError = props => {
  const { formik, onSubmissionError } = props;

  const effect = () => {
    if (formik.submitCount > 0 && !formik.isValid) {
      onSubmissionError();
    }
  };

  useEffect(effect, [formik.submitCount]);

  return null;
};

export default connect(OnSubmitValidationError);
